import { Box, styled } from '@arpeggi/ui'
import { ComponentProps, FC } from 'react'

const NumberContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  position: 'relative',
  width: '30px',
  height: '30px',
  minWidth: '30px',
  minHeight: '30px',
  marginRight: '20px',
  textFamily: 'dm-bold'
})

const NumberText = styled(Box, { color: '#000000', zIndex: 2, opacity: '70%' })

const NumberBackground = styled(Box, {
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  position: 'absolute'
})

const Number: FC<ComponentProps<typeof Box> & { backgroundColor: string }> = (props) => (
  <NumberContainer {...props}>
    <NumberText>{props.children}</NumberText>
    <NumberBackground css={{ backgroundColor: props.backgroundColor }} />
  </NumberContainer>
)

const Icon = NumberContainer

const Title = styled('div', {
  text: '16',
  textFamily: 'dm-bold',
  marginBottom: '8px'
})

const BodyText = styled('div', {
  text: '14'
})

const TextContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '450px'
})

const Root = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '30px'
})

export const BulletPoint = { Title, BodyText, Root, TextContainer, Number, Icon }
